<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-id"];
import { computed, inject, onBeforeUnmount, provide, useId } from "vue";
import { useMenuView } from "../composables/private/useMenuView";
import {
  MagicMenuInstanceId,
  MagicMenuViewId,
  MagicMenuParentTree,
  MagicMenuItemId,
  MagicMenuViewActive
} from "../symbols";
import { useMenuState } from "../composables/private/useMenuState";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicMenuView",
  props: {
    id: { type: String, required: false },
    placement: { type: null, required: false }
  },
  setup(__props) {
    const parentTree = inject(MagicMenuParentTree, []);
    const instanceId = inject(MagicMenuInstanceId, void 0);
    const itemId = inject(MagicMenuItemId, void 0);
    if (!instanceId) {
      throw new Error("MagicMenuView must be nested inside MagicMenuProvider");
    }
    const mappedId = computed(() => __props.id ?? `magic-menu-view-${useId()}`);
    const mappedParentTree = computed(() => [...parentTree, mappedId.value]);
    const mappedActive = computed(() => view.active);
    const { initializeView, deleteView } = useMenuView(instanceId);
    const { initializeState } = useMenuState(instanceId);
    const state = initializeState();
    const mappedPlacement = computed(() => {
      if (__props.placement) {
        return __props.placement;
      }
      switch (state.options.mode) {
        case "navigation":
          return "bottom";
        case "menubar":
          return !itemId ? "bottom-start" : "right-start";
        case "dropdown":
          return !itemId ? "bottom" : "right-start";
        case "context":
          return "right-start";
        default:
          return void 0;
      }
    });
    const view = initializeView({
      id: mappedId.value,
      parent: { views: parentTree, item: itemId ?? "" },
      placement: mappedPlacement.value ?? "bottom"
    });
    provide(MagicMenuParentTree, mappedParentTree.value);
    provide(MagicMenuViewId, mappedId.value);
    provide(MagicMenuViewActive, mappedActive);
    onBeforeUnmount(() => {
      deleteView(mappedId.value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        "data-id": mappedId.value,
        class: "magic-menu-view"
      }, [
        _renderSlot(_ctx.$slots, "default", {
          viewActive: _unref(view).active
        })
      ], 8, _hoisted_1);
    };
  }
});
</script>
